import clsx from "clsx"
import { Children, ReactNode } from "react"
import { ShippingIcon } from "src/components/icons"
import { StorefrontDetailVariant } from "src/types/storefront"
import { isVariantDigital, qualifiesForFreeShipping } from "src/utilities/product"

export type ShippingInfoProps = {
  initializing: boolean
  variant: StorefrontDetailVariant | undefined
  highlightFreeShipping?: boolean
  children: ReactNode
}

export const ShippingInfo = ({ initializing, variant, highlightFreeShipping, children }: ShippingInfoProps) => {
  const outOfStock = variant && !variant?.purchasable
  const digital = isVariantDigital(variant)

  if (initializing || outOfStock || digital) {
    return null
  }

  const price = variant?.pricing.calculatedPrice || 0
  const shippingIsFree = qualifiesForFreeShipping(price)

  return (
    <div className="text-subtle text-sm">
      {Children.map(children, (child, index) => {
        return index === 0 ? (
          <div className="flex items-center gap-2">
            <ShippingIcon
              className={clsx("inline h-4 w-4", {
                "text-success font-medium": shippingIsFree && highlightFreeShipping,
              })}
            />{" "}
            {child}
          </div>
        ) : (
          child
        )
      })}
    </div>
  )
}
